/**
 * Shared constants and value mappings for route lists
 */

/**
 * Trip status value mapping — shared across all Trips list views.
 *
 * Keep one entry per value in `TripStatus` (libs/shared/.../trip.entity.ts).
 * When a value is missing here the badge falls back to rendering the raw
 * snake_case enum, which surfaces to the user as "pending_load" instead
 * of "Pending Load". Three pending_* statuses were added 2026-05-12/13
 * (pending_load, pending_pre_trip_wm_review, pending_post_trip_wm_review)
 * and need their human labels here too.
 */
export const TRIP_STATUS_VALUE_MAPPING = [
	{
		value: 'pending_load',
		label: 'Pending Load',
		color: {
			bg: '#fde68a',
			text: '#92400e',
		},
	},
	{
		value: 'pending_pre_trip_wm_review',
		label: 'Pending Pre-Trip Review',
		color: {
			bg: '#fef3c7',
			text: '#b45309',
		},
	},
	{
		value: 'scheduled',
		label: 'Scheduled',
		color: {
			bg: '#dbeafe',
			text: '#1e40af',
		},
	},
	{
		value: 'in-progress',
		label: 'In Progress',
		color: {
			bg: '#fef3c7',
			text: '#92400e',
		},
	},
	{
		value: 'pending_post_trip_wm_review',
		label: 'Pending Post-Trip Review',
		color: {
			bg: '#fed7aa',
			text: '#9a3412',
		},
	},
	{
		value: 'completed',
		label: 'Completed',
		color: {
			bg: '#dcfce7',
			text: '#166534',
		},
	},
	{
		value: 'failed',
		label: 'Failed',
		color: {
			bg: '#fee2e2',
			text: '#991b1b',
		},
	},
	{
		value: 'cancelled',
		label: 'Cancelled',
		color: {
			bg: '#f3f4f6',
			text: '#6b7280',
		},
	},
] as const;
